import React, { useMemo } from 'react'
import { ListItem } from '@chakra-ui/react'
import {
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot,
} from 'react-beautiful-dnd'
import { IActionComponentProps } from '~core/forge.type'
import { ActionBase } from './ActionBase'
import { useUserAbilities } from '~editor/hooks/useUser'

interface IActionProps extends IActionComponentProps {
  index: number
}

function Action(props: IActionProps) {
  const abilities = useUserAbilities()
  const { actions, action, activeActionGesture, index } = props
  const id = `${action.id}-${action.type}`
  const canMoveActions = useMemo(
    () => abilities?.can('move', 'NodeActions'),
    [abilities],
  )

  return (
    <Draggable
      key={id}
      draggableId={id}
      index={index}
      isDragDisabled={!canMoveActions}
    >
      {(
        dragProvided: DraggableProvided,
        dragSnapshot: DraggableStateSnapshot,
      ) => (
        <ListItem
          key={id}
          ref={dragProvided.innerRef}
          {...dragProvided.draggableProps}
          {...dragProvided.dragHandleProps}
        >
          {!!action && (
            <ActionBase
              actions={actions}
              action={action}
              activeActionGesture={activeActionGesture}
            />
          )}
        </ListItem>
      )}
    </Draggable>
  )
}

export default Action
